import AssignAgent from './AssignAgent';

export default AssignAgent;
